export default "__VITE_ASSET__B$ykkZRe__"